import Airtable from "airtable";
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { serverEnv } from "#/lib/env/server";

const submitContactInfoSchema = z.object({
  email: z.string().email(),
  firstName: z.string().min(1),
  jobPostId: z.string().min(1),
  lastName: z.string().min(1),
  phone: z.string().min(1),
});

export type SubmitContactInfoState = {
  applicationId: string;
  message: string;
};

export const submitContactInfo = createServerFn({ method: "POST" })
  .inputValidator(submitContactInfoSchema)
  .handler(async ({ data }): Promise<SubmitContactInfoState> => {
    const base = new Airtable({
      apiKey: serverEnv.AIRTABLE_KEY,
    }).base("appjsTrV6e5h16Uta");

    try {
      const records = await base("Submissions").create([
        {
          fields: {
            email: data.email,
            first_name: data.firstName,
            job_post_id: data.jobPostId,
            last_name: data.lastName,
            phone: data.phone,
          },
        },
      ]);

      return {
        applicationId: records[0]?.id ?? "",
        message: "Application submitted",
      };
    } catch (error) {
      console.error("Error submitting contact info", error);

      return {
        applicationId: "",
        message: "We could not submit your application. Please try again.",
      };
    }
  });
